import { render, staticRenderFns } from "./QualificationInfo.vue?vue&type=template&id=5153317c&scoped=true"
import script from "./QualificationInfo.vue?vue&type=script&lang=js"
export * from "./QualificationInfo.vue?vue&type=script&lang=js"
import style0 from "./QualificationInfo.vue?vue&type=style&index=0&id=5153317c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5153317c",
  null
  
)

export default component.exports